import { render, staticRenderFns } from "./orderslist.vue?vue&type=template&id=6fad64a5&scoped=true&"
import script from "./orderslist.vue?vue&type=script&lang=js&"
export * from "./orderslist.vue?vue&type=script&lang=js&"
import style0 from "./orderslist.vue?vue&type=style&index=0&id=6fad64a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad64a5",
  null
  
)

export default component.exports